import React from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Image from '../../atoms/image/Image'
import Card from '../../atoms/card/Card'
import ArrowHeader from './components/ArrowHeader'
import Icon from '../../atoms/icon/Icon'

import Theme from '../../../styles/_theme.module.scss'
import './RoundResultsTablePage.scss'

interface Props {
  data: ModelAPI.Reporting.NextDealRoom
}

const getDotColour = (idx: number) => {
  switch (idx) {
    case 0: return Theme.yellow
    case 1: return Theme.green
    case 2: return Theme.blue
    default: return 'blue'
  }
}

const RoundResultsDealRoomInformation: React.FC<Props> = ({ data }) => {

  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-2'>Deal Room</Text>
      <InlineGroup fullHeight>
        <Card wide sharp padding={0}>
          <InlineGroup fullHeight block>
            <InlineGroup block className='decisions-table-image-wrapper mt-4 mb-4 ml-4'>
              <Image src={data.imageUrl} alt='Deal Room Image' style={{width: '100%', height: '100%', objectFit: 'cover', backgroundPosition: 'center'}} />
              <Text size="4xl" className="decisions-table-image-overlay">
                {data.name}
              </Text>
            </InlineGroup>
            <VerticalGroup spread full className='mt-4' wide>
              <ArrowHeader text='Deal Overview' colour={Theme.primaryDark}></ArrowHeader>
              {data.overviewQuestion && <InlineGroup verticalCenter style={{border: `2px solid ${Theme.blue}`}} className='ml-10 mb-4 mt-8 mr-10'>
                <Icon style={{backgroundColor: Theme.blue, margin: 0}} colour='white' size={20} type='help' className='p-3'></Icon>
                <VerticalGroup>
                  {data.overviewQuestion.split('?').map(q => {
                    if (!!q) {
                      return <Text key={q} size='xl' bold className='pl-4 pr-4'>{q}?</Text>
                    }
                    return null
                  })}
                </VerticalGroup>
              </InlineGroup>}
              <VerticalGroup full className='mt-4 pb-4'>
                <VerticalGroup className='pl-10 pr-2' spaceBetweenElements={10} full>
                  <VerticalGroup>
                    {data.overviewDescription.split('\n').map(d => (
                      <Text key={d} size='lg' className='pb-2'>{d}</Text>
                    ))}
                  </VerticalGroup>
                  {!!data.decide && data.decide.decisions.length > 0 && <VerticalGroup spaceBetweenElements={8} full>
                    <Text size='lg' bold>You'll need to decide:</Text>
                    <VerticalGroup full>
                      {data.decide.decisions.map(
                        (d: any, i) => (
                          <InlineGroup key={i} fullHeight>
                            <VerticalGroup center>
                              <div className='options-dot mr-4' style={{backgroundColor: getDotColour(i)}}></div>
                              {i >= data.decide!.decisions.length - 1 ? <span className='dot-separator mr-4 mt-1' />  : <span className='dot-separator mr-4 mt-1 mb-1' />}
                            </VerticalGroup>
                            <VerticalGroup>
                              <InlineGroup block verticalCenter>
                                <Text size='lg'>{d}</Text>
                              </InlineGroup>
                            </VerticalGroup>
                          </InlineGroup>
                        )
                      )}
                    </VerticalGroup>
                  </VerticalGroup>}
                </VerticalGroup>
              </VerticalGroup>
            </VerticalGroup>
          </InlineGroup>
        </Card>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsDealRoomInformation

